import { ACCESS_TOKEN_EXPIRATION_TIME, SAME_SITE_STRICT } from '@constants/cookies';
import Cookies from 'js-cookie';

import { ACCESS_TOKEN_KEY, STORAGE_ACCESS_TOKEN_KEY, STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY } from './constants';
import { cookieDomain } from './constants';

export const setAccessToken = ({ key, token }: { key: string; token: string }) => {
  const maxMinutesAccessToken = new Date(Date.now() + Number(ACCESS_TOKEN_EXPIRATION_TIME));
  Cookies.set(key, token, {
    domain: cookieDomain,
    path: '/',
    sameSite: SAME_SITE_STRICT,
    secure: true,
    expires: maxMinutesAccessToken,
  });
  const storageKey: string = key === ACCESS_TOKEN_KEY ? STORAGE_ACCESS_TOKEN_KEY : STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY;
  sessionStorage.setItem(storageKey, token);
};
